import React, { useState } from 'react';
import { connect } from 'react-redux';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { ReduxState } from '../../interfaces';
import * as Actions from '../../modules/devices/actions';
import * as Devices from '../../modules/devices';
import DialogFooter from '../shared/dialog/dialogFooter';
import DialogHeader from '../shared/dialog/dialogHeader';
import Translate from '../shared/localization/localize';
import { AppKeys, newMsg } from '../../core/localization';
import useDialog from '../shared/dialog/useDialog';

interface StateProps {
  selectedKeys: string[];
  actionStatus: Devices.ActionStatus;
}

type IProps = StateProps;

const ActivateDialog: React.FC<IProps> = (props) => {
  const {setDialog} = useDialog();
  const [error] = useState('');

  const infoText = (
    <Translate
      message={newMsg(AppKeys.Dialog_Activate_summary, [
        { tag: 'count', value: props.selectedKeys.length },
      ])}
    />
  );

  const onClick = () => Actions.activate(props.selectedKeys);
  const removeButton = (
    <KFLButton
      id="dg-activate-bt-activate"
      key="md-activate-bt-activate"
      onClick={onClick}
    >
      <Translate message={newMsg(AppKeys.Btn_Activate)} />
    </KFLButton>
  );
  const buttons: JSX.Element[] = [removeButton];

  const footerText = props.actionStatus.isActivating ? (
    <Translate message={newMsg(AppKeys.Dialog_Activate_fetching)} />
  ) : (
    <span style={{ color: 'red' }}>{error}</span>
  );

  return (
      <KFLDialog
        header={
          <DialogHeader
            title={
              <Translate message={newMsg(AppKeys.Dialog_Activate_Header)} />
            }
            fnCloseDialog={() => setDialog?.()}
          />
        }
        sections={[infoText]}
        footer={
          <DialogFooter
            leftContent={footerText}
            buttons={buttons}
            fnCloseDialog={() => setDialog?.()}
          />
        }
      />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  selectedKeys: state.devicesState.selection.selectedKeys,
  actionStatus: state.devicesState.actionStatus,
});

export default connect(mapStateToProps)(ActivateDialog);
